import React, { Component, Suspense } from "react";
import * as ReactDOM from "react-dom";
import Slider from "react-slick";
import $ from "jquery";
import edit from "../image/icons/edit.png";
import plus from "../image/icons/plus.png";
import ReactPlayer from "react-player";
const folderName = window.sessionStorage.getItem("homeName");
let imageFlag = "";
let vcLinks = "";
export default class Gallery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bouquetData: [],
      SubList: [],
      sectionName: "Bouquet",
      parentName: "",
      imageFlag: "",
      videFlag: "",
    };
  }
  componentDidMount() {
    const Bouquet = JSON.parse(window.sessionStorage.getItem("Bouquet"));
    if (Bouquet) {
      this.setState({ bouquetData: Bouquet });
      this.setState({ SubList: Bouquet[0].sectionList });
      this.setState({ parentName: Bouquet[0].parentName });
    } else {
      //window.location.reload(false);
    }
  }
  addClick(
    sid,
    pId,
    cId,
    psubTitle,
    cTitile,
    cdescri,
    childUrl,
    childImg,
    sOrder
  ) {
    if ($("#BouquetParentId").val() !== "") {
      pId = $("#BouquetParentId").val();
    }
    if (childImg) {
      var splitImg = childImg.split("theme/");
      childImg = splitImg[1];
    }
    const LazyPage = React.lazy(() =>
      import("../" + folderName + "/ThemeComponent")
    );
    ReactDOM.render(
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <section>
            <LazyPage
              sessionId={sid}
              parentId={pId}
              childId={cId}
              patentTitle={this.state.parentName}
              parentSubTitle={psubTitle}
              childTitle={cTitile}
              childDesri={cdescri}
              sectionName={this.state.sectionName}
              childUrl={childUrl}
              childImg={childImg}
              sortSubOrder={sOrder}
            />
          </section>
        </Suspense>
      </div>,
      document.getElementById("gallarypopUpBlock")
    );
    $("#gallarypopUpBlock").addClass("editActive");
  }

  checkURL(url) {
    return url.match(/\.(jpeg|jpg|gif|png|MOV|mp4|MKV)$/) != null;
  }

  render() {
    var settingsGallry = {
      dots: false,
      infinite: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 800,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    window.$(document).ready(function () {
      window.$(".popup-gallery").magnificPopup({
        delegate: "a",
        type: "iframe",
        tLoading: "Loading...",
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1],
        },
      });
      window.$(".popup-image").magnificPopup({
        delegate: "a",
        type: "image",
        tLoading: "Loading...",
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1],
        },
      });
    });
    const urlPath = window.location.origin.toString();
    return (
      <div class="gallery-mainwapper">
        <div class="container">
          <h4 className="mainHead  text-center">
            <span>
              {this.state.parentName != "" ? this.state.parentName : "Gallery"}
            </span>
          </h4>
          {this.props.themeFlag == "theme" && (
            <div className="editIconSec" id="Advertisement">
              <span
                className="editIcon editAddIcon"
                title="Add"
                onClick={() =>
                  this.addClick("9", "", "", "", "", "", "", "", "")
                }
              >
                <img src={plus} alt="Add" />
              </span>
            </div>
          )}
          <div className="cmsContentDiv" id="gallarypopUpBlock"></div>
          <input type="hidden" id="BouquetSectionId" value="9" />
          {this.state.bouquetData.map((data, index) => {
            return (
              <div class="gallery-main">
                <input
                  type="hidden"
                  id="BouquetParentId"
                  value={data.parentId}
                />
                {data.sectionList.length !== "0" && (
                  <Slider {...settingsGallry}>
                    {data.sectionList.map((ban) => {
                      // {this.state.SubList.map((ban) => {
                      if (ban.childImage.match(/.(jpg|jpeg|png|gif)$/i)) {
                        //this.setState({imageFlag:"1"})
                        imageFlag = "1";
                        //alert("image.... "+ban.childImage)
                      } else if (ban.childImage.match(/.(MOV|mp4|MKV)$/i)) {
                        //this.setState({imageFlag:"0"})
                        imageFlag = "0";
                        //alert("video... "+ban.childImage)
                      } else {
                        imageFlag = "2";
                        if (ban.childUrl.match(/.(MOV|mp4|MKV)$/i)) {
                          vcLinks = "0";
                        } else {
                          vcLinks = "1";
                        }
                      }
                      return (
                        <div
                          className={
                            ban.childUrl === ""
                              ? ban.childImage.match(/.(MOV|mp4|MKV)$/i)
                                ? "galleryImageDiv  popup-gallery"
                                : "galleryImageDiv popup-image"
                              : "galleryImageDiv  popup-gallery"
                          }
                        >
                          {this.props.themeFlag === "theme" && (
                            <div className="editIconSec">
                              <span
                                className="editIcon editAddIcon"
                                title="Edit"
                                onClick={() =>
                                  this.addClick(
                                    data.sectionId,
                                    data.parentId,
                                    ban.childId,

                                    data.parentSubTitle,
                                    ban.childName,
                                    ban.childDescription,
                                    ban.childUrl,
                                    ban.childImage,
                                    ban.homeAdsSubSortOrder
                                  )
                                }
                              >
                                <img src={edit} alt="logo" />
                              </span>
                            </div>
                          )}
                          {imageFlag === "1" ? (
                            <a href={ban.childImage} target="_blank">
                              <img
                                src={ban.childImage}
                                alt="gallery image"
                                className="img-fluid"
                              />
                            </a>
                          ) : imageFlag === "0" ? (
                            <a href={ban.childImage} target="_blank">
                              <video controls>
                                <source src={ban.childImage} type="video/mp4" />
                                <source src={ban.childImage} type="video/ogg" />
                              </video>
                            </a>
                          ) : vcLinks === "1" ? (
                            <a href={ban.childUrl} target="_blank">
                              <ReactPlayer
                                url={ban.childUrl}
                                width="100%"
                                height="100%"
                              />
                            </a>
                          ) : (
                            <a href={ban.childUrl} target="_blank">
                              <video controls>
                                <source src={ban.childUrl} type="video/mp4" />
                                <source src={ban.childUrl} type="video/ogg" />
                              </video>
                            </a>
                          )}
                        </div>
                      );
                    })}
                  </Slider>
                )}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
